export const getDefaultSeriesData = () => {
  const res = {
    UIRx_ACULatAcc: [],
    UIRx_ACULongdAcc: [],
  } as DomianControl.IVSESeriesData;
  return res;
};

export const transformSeriesData = (data: DomianControl.IVSENotifyData) => {
  const res = Object.keys(data).reduce((acc, key) => {
    let value = data[key];
    // const newKey = "UIRx_" + key;
    // 取反
    if (["UIRx_ACULongdAcc", "UIRx_BetaObs"].includes(key)) {
      value = -value;
    }
    acc[key] = value;
    return acc;
  }, {} as DomianControl.IVSENotifyData);
  return res;
};
